/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Go_NowInputs */

const en_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Now`)
};

const ar_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إذهب الآن`)
};

const de_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt gehen`)
};

const es_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir ahora`)
};

const fr_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est parti`)
};

const it_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai Adesso`)
};

const ja_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チェックする`)
};

const ko_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`바로 가기`)
};

const pt_br_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir agora`)
};

const ru_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить сейчас`)
};

const th_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไปตอนนี้`)
};

const tr_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi Git`)
};

const zh_cn_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即前往`)
};

const zh_tw_btn_go_now = /** @type {(inputs: Btn_Go_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即前往`)
};

/**
* | output |
* | --- |
* | "Go Now" |
*
* @param {Btn_Go_NowInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_go_now = /** @type {((inputs?: Btn_Go_NowInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Go_NowInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_go_now(inputs)
	if (locale === "ar") return ar_btn_go_now(inputs)
	if (locale === "de") return de_btn_go_now(inputs)
	if (locale === "es") return es_btn_go_now(inputs)
	if (locale === "fr") return fr_btn_go_now(inputs)
	if (locale === "it") return it_btn_go_now(inputs)
	if (locale === "ja") return ja_btn_go_now(inputs)
	if (locale === "ko") return ko_btn_go_now(inputs)
	if (locale === "pt_br") return pt_br_btn_go_now(inputs)
	if (locale === "ru") return ru_btn_go_now(inputs)
	if (locale === "th") return th_btn_go_now(inputs)
	if (locale === "tr") return tr_btn_go_now(inputs)
	if (locale === "zh_cn") return zh_cn_btn_go_now(inputs)
	return zh_tw_btn_go_now(inputs)
});